import { Helmet } from "react-helmet"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import '../shared/styles/otherPageStyle.css'
const SitePlanPage=()=>{
    const { t } = useTranslation();
    return (
      <div className='other-page'>
        <div className='container'>
          <Helmet>
            <title>{t('site-map--title')}</title>
            <style>
              {`
             .content-main{
                background-image:none
            };
             .lng-container{
                display:none
             }
            `}
            </style>
          </Helmet>

          <h1>{t('site-map')}</h1>
          <ul className='sitemap'>
            <li>
              <NavLink to='/'>
                <h2>{t('site-map--homepage')}</h2>
              </NavLink>
            </li>

            <li>
              <h2>{t('site-map--evda')}</h2>

              <ul>
                <li>
                  <NavLink to='/EVDA/EUROPE'>
                    <h3>• {t('site-map--evda-europe')}</h3>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/EVDA'>
                    <h3>• {t('site-map--evda-france')}</h3>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/EVDA/DEPARTMENTS'>
                    <h3>• {t('site-map--evda-departement')}</h3>
                  </NavLink>
                </li>
              </ul>
            </li>
            <li>
              <h2>{t('evmc-title')}</h2>

              <ul>
                <li>
                  <NavLink to='/EVMC'>
                    <h3>• {t('evmc-living')}</h3>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/EVMC/EDUCATION'>
                    <h3>• {t('evmc-education')}</h3>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/EVMC/CATEGORY'>
                    <h3>• {t('evmc-category')}</h3>
                  </NavLink>
                </li>
              </ul>
            </li>
            <li>
              <NavLink to='/static/more'>
                <h2>{t('site-map--more')}</h2>
              </NavLink>
            </li>
            <li>
              <NavLink to='/static/accessibility'>
                <h2>{t('site-map--accessibility')}</h2>
              </NavLink>
            </li>
            <li>
              <NavLink to='/static/legal-notice'>
                <h2>{t('site-map--legal-notice')}</h2>
              </NavLink>
            </li>
            <li>
              <NavLink to='/static/conditions'>
                <h2>{t('site-map--conditions')}</h2>
              </NavLink>
            </li>
            <li>
              <NavLink to='/plan-site'>
                <h2>{t('site-map--site-map')}</h2>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    );
}

export default SitePlanPage